import { Link } from "react-router-dom";
import type { ReactNode } from "react";

/**
 * One link component for every destination we use:
 *  - "https://..."  -> external anchor, opened in a new tab
 *  - "/pricing"     -> client-side route
 *  - "/#features"   -> route + hash (the layout scrolls to the section)
 *
 * Keeps Navbar/Footer from having to know which is which.
 */
export default function SmartLink({
  href,
  className,
  children,
  onNavigate,
  ariaLabel,
}: {
  href: string;
  className?: string;
  children: ReactNode;
  onNavigate?: () => void;
  ariaLabel?: string;
}) {
  if (/^https?:\/\//i.test(href)) {
    return (
      <a
        href={href}
        className={className}
        aria-label={ariaLabel}
        target="_blank"
        rel="noreferrer noopener"
      >
        {children}
      </a>
    );
  }

  return (
    <Link to={href} className={className} aria-label={ariaLabel} onClick={onNavigate}>
      {children}
    </Link>
  );
}
